import styled from '@emotion/styled';
import { DatePicker as AntdDateTimePicker } from 'antd';

import { shadow } from 'src/shared/styles/variables';

interface DateTimePickerProps {
    wide?: boolean;
}

export const DateTimePicker = styled(AntdDateTimePicker)<DateTimePickerProps>(({ wide }) => ({
    '&.ant-time-picker, &.ant-calendar-picker': {
        width: `${wide ? '100%' : '14.88rem'} !important`, // Antd uses element style
        boxShadow: shadow.lightShadow,
        '&& .ant-time-picker-icon, && .ant-calendar-picker-icon': {
            display: 'none',
        },
        '&& .ant-input': {
            padding: wide ? '0.44rem 0.88rem' : 'auto',
            height: wide ? '2.19rem' : 'auto',
        },
    },
}));
